import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import es from '../locales/es.json';
import en from '../locales/en.json';
import ca from '../locales/ca.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      ca: { translation: ca },
    },
    fallbackLng: 'es',
    supportedLngs: ['es', 'en', 'ca'],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'zbilling_lang',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
